import * as React from "react";

export function useProductDetailFormatters() {
  const formatMoneyData = React.useCallback(
    (
      amount: number,
      currencySymbol = "$",
      thousandsSeparator = ",",
    ) => {
      const roundedAmount = Math.round(amount * 100) / 100;
      const amountString = roundedAmount.toFixed(2);
      const [integerPart] = amountString.split(".");
      const integerWithThousands = integerPart.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        thousandsSeparator,
      );
      return currencySymbol + integerWithThousands;
    },
    [],
  );

  const formatQuantityData = React.useCallback(
    (amount: number, thousandsSeparator = ",") => {
      const roundedAmount = Math.round(amount * 100) / 100;
      const amountString = roundedAmount.toFixed(2);
      const [integerPart] = amountString.split(".");
      return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    },
    [],
  );

  return { formatMoneyData, formatQuantityData };
}
